import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
// eslint-disable-next-line
import App from './components/App'
import Firebase, { FirebaseContext } from './Firebase'
import FirebaseListeners from './Firebase/FirebaseListeners'
import reducer, { initialState } from './reducers'
import app from './Firebase/config'
import firebaseMiddleware from './Firebase/firebaseMiddleware'
import { resetState } from './actions'

import './index.css'

const firebase = new Firebase(app)

const store = createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(thunk, firebaseMiddleware(firebase)),
  ),
)

const firebaseListeners = new FirebaseListeners(firebase, store)
app.auth().onAuthStateChanged(function (user) {
  if (user) {
    store.dispatch(resetState())
    firebaseListeners.startListening()
  } else {
    store.dispatch(resetState())
    firebaseListeners.stopListening()
  }
})

ReactDOM.render(
  <FirebaseContext.Provider value={firebase}>
    <Provider store={store}>
      <App />
    </Provider>
  </FirebaseContext.Provider>,
  document.getElementById('root'),
)
